import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSquareFrame16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M2.5 5.33333V3.16667C2.5 2.79848 2.79848 2.5 3.16667 2.5H5.33333M2.5 10.6667V12.8333C2.5 13.2015 2.79848 13.5 3.16667 13.5H5.33333M10.6667 2.5H12.8333C13.2015 2.5 13.5 2.79848 13.5 3.16667V5.33333M13.5 10.6667V12.8333C13.5 13.2015 13.2015 13.5 12.8333 13.5H10.6667M6.5 10.1667H9.5C9.8682 10.1667 10.1667 9.8682 10.1667 9.5V6.5C10.1667 6.13181 9.8682 5.83333 9.5 5.83333H6.5C6.13181 5.83333 5.83333 6.13181 5.83333 6.5V9.5C5.83333 9.8682 6.13181 10.1667 6.5 10.1667Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoSquareFrame16;